import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { DAY_OF_WEEK } from '../../fields';
import { DAY_OF_WEEK_VIDEO_REPORT_ID } from './dayWeekVideoReportId';

const dayOfWeekReportFooterColumnDefinition = [DAY_OF_WEEK].map(createFooterMapper(DAY_OF_WEEK_VIDEO_REPORT_ID));

export default dayOfWeekReportFooterColumnDefinition;
